// src/routes/ProtectedDriverRoute.jsx
import { useEffect, useRef } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { useDriver } from "../context/DriverContext";

const ProtectedDriverRoute = ({ children }) => {
  const { driver, loading, logout } = useDriver();
  const location = useLocation();
  const navigate = useNavigate();
  const deactivatedRef = useRef(false);

  useEffect(() => {
    if (driver && driver.status !== "active") {
      logout(); // clears cookie + driver state
      deactivatedRef.current = true; // mark that we triggered deactivation redirect
      navigate("/driver-login?reason=deactivated", { replace: true });
    }
  }, [driver, logout, navigate]);

  if (loading) {
    return <p className="text-center mt-20">Loading...</p>;
  }

  // Only redirect to login normally if not deactivated
  if (!driver && !deactivatedRef.current) {
    return <Navigate to="/driver-login" state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedDriverRoute;
